import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VListItem,
        { key: _vm.item.name },
        [
          _c(
            VListItemContent,
            [
              _c(VListItemTitle, {
                attrs: { primary: "" },
                domProps: { textContent: _vm._s(_vm.item.titulo) },
              }),
              _c(VListItemSubtitle, { staticClass: "text--primary" }, [
                _vm._v(
                  _vm._s(_vm.item.dataset) +
                    " / " +
                    _vm._s(_vm.item.titulo) +
                    " "
                ),
              ]),
              _c(VListItemSubtitle, { staticClass: "text--primary" }, [
                _c("b", [_vm._v("Description:")]),
                _vm._v(" " + _vm._s(_vm.item.description) + " "),
              ]),
              _c(VListItemSubtitle, { staticClass: "text--primary" }, [
                _c("b", [_vm._v("Data Operator:")]),
                _vm._v(" " + _vm._s(_vm.item.data_operator) + " "),
              ]),
              _c(VListItemSubtitle, { staticClass: "text--primary" }, [
                _c("b", [_vm._v("Dominio:")]),
                _vm._v(" " + _vm._s(_vm.item.dominio)),
              ]),
              _vm.item.distance !== undefined
                ? _c(
                    VListItemSubtitle,
                    [
                      _c("b", [_vm._v("Similitud semántica:")]),
                      _c(
                        VChip,
                        {
                          staticClass: "mx-1",
                          attrs: {
                            "x-small": "",
                            color: _vm.similarityColor(_vm.item.distance),
                            dark: "",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.similarityPercent(_vm.item.distance)) +
                              "%"
                          ),
                        ]
                      ),
                      _c(VProgressLinear, {
                        staticStyle: {
                          "max-width": "120px",
                          display: "inline-flex",
                          "vertical-align": "middle",
                        },
                        attrs: {
                          value: _vm.similarityPercent(_vm.item.distance),
                          color: _vm.similarityColor(_vm.item.distance),
                          height: "4",
                          rounded: "",
                        },
                      }),
                    ],
                    1
                  )
                : _c(VListItemSubtitle, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("search.found_in")) +
                          " " +
                          _vm._s(_vm.item.field) +
                          ": "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.item.snippet) },
                    }),
                  ]),
            ],
            1
          ),
          _c(
            VListItemAction,
            [
              _c(
                VBtn,
                {
                  staticClass: "btn-inca",
                  class: "color-" + _vm.item.tipo_objeto,
                  attrs: { "x-small": "", dark: "" },
                },
                [_vm._v(_vm._s(_vm.item.tipo_objeto))]
              ),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-1",
                      attrs: {
                        "x-small": "",
                        outlined: "",
                        color: "secondary",
                        dark: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onVerObjeto(_vm.item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.view")))]
                  ),
                  _vm.item.tipo_objeto !=
                  _vm.TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET
                    ? _c(
                        VBtn,
                        {
                          staticClass: "ml-1",
                          attrs: {
                            "x-small": "",
                            outlined: "",
                            color: "secondary",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onRequestObjeto(_vm.item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("search.request")))]
                      )
                    : _vm._e(),
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-1",
                      attrs: {
                        "x-small": "",
                        outlined: "",
                        color: "secondary",
                        dark: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onChangeObjeto(_vm.item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.change")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }